import React, { forwardRef } from 'react';
import styles from './IconButton.module.scss';
import { getClassName } from '@onsolve-ucl/utils.get-class-name';
const IconButton = forwardRef(({ children, className, type = 'button', ...otherProps }, ref) => {
    const [rootClass] = getClassName({
        styles,
        rootClass: 'iconButton',
        className,
    });
    return (<button {...otherProps} className={rootClass} type={type} ref={ref}>
                {children}
            </button>);
});
IconButton.displayName = 'IconButton';
export default IconButton;
